import Vue from 'vue';

import Module from '@/scripts/old/classes/Module';
import Analytics from '@/scripts/old/helpers/Analytics';
import { parseAttr } from '@/scripts/old/helpers/utils';

import Roulette from './Roulette.vue';

const NAMESPACE = 'data-roulette';

class RoulettesModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const mountingPoint = document.createElement('div');
    el.appendChild(mountingPoint);

    const config = parseAttr(el, NAMESPACE);

    const isSuperGame = !!config.superGameStatus;
    const sendUrl = config.sendUrl;
    const shareParams = config.shareParams;
    const rollSpeed = config.rollSpeed || 180;
    const fakeRolls = config.fakeRolls || 1;

    const pies = config.pies;
    const randomUrl = config.randomUrl;
    const attemptsDone = !isSuperGame ? parseInt(config.attemptsDone, 10) : 2;
    const discountId = !isSuperGame ? config.savedDiscountPie : undefined;
    const discountTimestamp = !isSuperGame ? config.timeStamp : undefined;
    const discountSent = !isSuperGame ? !!config.sent : undefined;

    const piesSuper = config.piesSuper;
    const randomUrlSuper = config.randomSuperUrl;
    const attemptsDoneSuper = isSuperGame ? parseInt(config.attemptsDone, 10) : 0;
    const discountIdSuper = isSuperGame ? config.savedDiscountPie : undefined;
    const discountTimestampSuper = isSuperGame ? config.timeStamp : undefined;
    const discountSentSuper = isSuperGame ? !!config.sent : undefined;

    if (!pies || !piesSuper || !randomUrl || !randomUrlSuper || !sendUrl) {
      return;
    }

    const roulette = new Vue({
      el: mountingPoint,
      data: {
        isSuperGame,
        sendUrl,
        shareParams,
        rollSpeed,
        fakeRolls,

        pies,
        randomUrl,
        attemptsDone,
        discountId,
        discountTimestamp,
        discountSent,

        piesSuper,
        randomUrlSuper,
        attemptsDoneSuper,
        discountIdSuper,
        discountTimestampSuper,
        discountSentSuper,
      },
      methods: {
        onPlay({ attempt }) {
          if (attempt === 1) {
            Analytics.reachGoal('RouletteTry1');
          } else if (attempt === 2) {
            Analytics.reachGoal('RouletteTry2');
          }
        },
        onGetDiscount() {
          Analytics.reachGoal('RouletteButtonGetDisc1');
        },
        onInitSuper() {
          Analytics.reachGoal('RouletteButtonTrySuper');
        },
        onShare({ target }) {
          switch (target) {
            case 'vk':
              Analytics.reachGoal('RouletteShareVK');
              break;
            case 'fb':
              Analytics.reachGoal('RouletteShareFB');
              break;
            case 'ok':
              Analytics.reachGoal('RouletteShareOK');
              break;
            case 'tw':
              Analytics.reachGoal('RouletteShareTW');
              break;
            default:
              break;
          }
        },
        onShareSuccess({ target }) {
          this.isSuperGame = true;
          switch (target) {
            case 'vk':
              Analytics.reachGoal('RouletteShareVKSuccess');
              break;
            case 'fb':
              Analytics.reachGoal('RouletteShareFBSuccess');
              break;
            case 'ok':
              Analytics.reachGoal('RouletteShareOKSuccess');
              break;
            case 'tw':
              Analytics.reachGoal('RouletteShareTWSuccess');
              break;
            default:
              break;
          }
        },
        onPlaySuper() {
          Analytics.reachGoal('RouletteSuperGame');
        },
        onGetDiscountSuper() {
          Analytics.reachGoal('RouletteButtonGetDisc2');
        },
      },
      render(h) {
        let roulette;

        if (this.isSuperGame) {
          roulette = h(Roulette, {
            props: {
              isSuper: true,
              attempts: 1,
              attemptsDone: this.attemptsDoneSuper,
              discountId: this.discountIdSuper,
              discountTimestamp: this.discountTimestampSuper,
              discountSent: this.discountSentSuper,
              randomUrl: this.randomUrlSuper,
              sendUrl: this.sendUrl,
              pies: this.piesSuper,
              rollSpeed: this.rollSpeed,
              fakeRolls: this.fakeRolls,
            },
            on: {
              play: this.onPlaySuper,
              'get-discount': this.onGetDiscountSuper,
            },
          });
        } else {
          roulette = h(Roulette, {
            props: {
              attempts: 2,
              attemptsDone: this.attemptsDone,
              discountId: this.discountId,
              discountTimestamp: this.discountTimestamp,
              discountSent: this.discountSent,
              randomUrl: this.randomUrl,
              sendUrl: this.sendUrl,
              pies: this.pies,
              rollSpeed: this.rollSpeed,
              fakeRolls: this.fakeRolls,
            },
            on: {
              play: this.onPlay,
              'get-discount': this.onGetDiscount,
              'init-super': this.onInitSuper,
              share: this.onShare,
              'share-success': this.onShareSuccess,
            },
          });
        }

        return h('div', { key: this.isSuperGame }, [roulette]);
      },
    });

    this.instances.set(el, roulette);
  }

  destroyInstance(instance) {
    instance.$destroy();
    instance.$el.parentElement.removeChild(instance.$el);
  }
}

export default new RoulettesModule();
